import React, { useCallback, useContext, useMemo } from 'react';
import { useGoogleAnalytics } from '../modules/GoogleAnalytics/hooks/useGoogleAnalytics';
import { useAnalyticsReportsDefinitionsQuery } from '../queries/useAnalyticsReportsDefinitionsQuery';
export const AnalyticsContext = React.createContext(undefined);
export const AnalyticsProvider = ({ children }) => {
    const { analyticsReportsDefinitionsQuery } = useAnalyticsReportsDefinitionsQuery(undefined, {
        staleTime: Infinity,
        cacheTime: Infinity,
        keepPreviousData: true,
    });
    const { data } = useGoogleAnalytics();
    const isGoogleAnalyticsEnabled = data?.type === 'CONNECTED';
    const availableReports = {
        conversion_rates: isGoogleAnalyticsEnabled,
        visitors: isGoogleAnalyticsEnabled,
        sales_by_source: isGoogleAnalyticsEnabled,
        sessions_by_source: isGoogleAnalyticsEnabled,
        average_order_value: true,
        sales_by_country: true,
        sales_by_utm: true,
        payment_method_used: true,
    };
    const reportsDefinitions = (analyticsReportsDefinitionsQuery.data || []).filter((report) => availableReports[report.id]);
    const getReportDefinition = useCallback((reportId) => {
        if (!reportId)
            return;
        return reportsDefinitions.find(({ id }) => id === reportId);
    }, [reportsDefinitions]);
    const value = useMemo(() => ({
        isLoading: analyticsReportsDefinitionsQuery.isFetching,
        reportsDefinitions,
        getReportDefinition,
    }), [analyticsReportsDefinitionsQuery.isFetching, getReportDefinition, reportsDefinitions]);
    return React.createElement(AnalyticsContext.Provider, { value: value }, children);
};
export const useAnalyticsContext = () => {
    const context = useContext(AnalyticsContext);
    if (context === undefined) {
        throw new Error('useAnalyticsContext must be used within an AnalyticsProvider');
    }
    return context;
};
